import { ofType } from "redux-observable";
import { filter, map } from "rxjs/operators";
import { TypeActionPlayerInfo } from "../../info/player/actionPlayerInfo";
import { actionAppsflyerUpdate } from "../actionAppsflyer";
import { IdAppsflyerEvents } from "../IdAppsflyerEvents";
export var epicAppsflyerCurrentLevel = function (action$, state$, deps) {
    return action$.pipe(ofType(TypeActionPlayerInfo.Received), filter(function (action) {
        return action.playerInfo != undefined && action.playerInfo.level != undefined;
    }), map(function (action) {
        var eventName = IdAppsflyerEvents.CURRENT_LEVEL;
        var eventValue = {
            LEVEL: action.playerInfo.level,
        };
        return actionAppsflyerUpdate(eventName, eventValue);
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/appsflyer/epics/epicAppsflyerCurrentLevel.ts
// module id = 1772
// module chunks = 3